import { Utils } from 'vue-graphql-models';

export default {
  setDosingEntriesToStore(state, dosingEntries) {
    Object.assign(state, { dosingEntries });
  },
  setDosingEntriesBackupToStore(state, dosingEntries) {
    const backupDosingEntries = Utils.cloneDeep(dosingEntries);
    Object.assign(state, { backupDosingEntries });
  },
  revertDosingChange(state, dosingKey) {
    const changed = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    const backedUp = state.backupDosingEntries.find(dosing => dosing._key === dosingKey);
    if (!changed || !backedUp) {
      return;
    }
    Object.assign(changed, backedUp);
  },
  changeBackedUpDosing(state, dosingKey) {
    const changed = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    const backedUp = state.backupDosingEntries.find(dosing => dosing._key === dosingKey);
    if (!changed || !backedUp) {
      return;
    }
    Object.assign(backedUp, changed);
  },
  switchDosingRatePumpCycles(state, dosingKey) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp,
      {
        dosageRate: true,
        pumpCycles: false,
      },
    );
  },
  switchPumpCyclesDosingRate(state, dosingKey) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp,
      {
        dosageRate: false,
        pumpCycles: true,
      },
    );
  },
  switchGPDPPM(state, dosingKey) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp,
      {
        gallonsPerDay: true,
        partsPerMillion: false,
      },
    );
  },
  switchPPMGPD(state, dosingKey) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp,
      {
        gallonsPerDay: false,
        partsPerMillion: true,
      },
    );
  },
  changeCountedValue(state, { dosingKey, targetValue, value }) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp,
      {
        [targetValue]: value,
      },
    );
  },
  changeCountedRateTypeValue(state, {
    dosingKey, dosingRateType, targetValue, value,
  }) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp[dosingRateType],
      {
        [targetValue]: value,
      },
    );
  },
  switchDosingRateManualAuto(state, dosingKey) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp.flowRateData,
      {
        auto: true,
        manual: false,
      },
    );
  },
  switchDosingRateAutoManual(state, dosingKey) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp.flowRateData,
      {
        auto: false,
        manual: true,
      },
    );
  },
  switchDosingRateMCFDBBLD(state, dosingKey) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp.flowRateData,
      {
        mcfd: false,
        bbld: true,
      },
    );
  },
  switchDosingRateBBLDMCFD(state, dosingKey) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp.flowRateData,
      {
        mcfd: true,
        bbld: false,
      },
    );
  },
  switchDosingRatePPMGPD(state, dosingKey) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp.targetDosingData,
      {
        gpd: true,
        ppm: false,
      },
    );
  },
  switchDosingRateGPDPPM(state, dosingKey) {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    if (!temp) {
      return;
    }
    Object.assign(
      temp.targetDosingData,
      {
        gpd: false,
        ppm: true,
      },
    );
  },
};
